import React from "react";
import { Table } from "antd";
/**
 * @param {{
 * dataSource: Array, // Data to show in the table
 * columns: Array, // Array of columns to show in the table
 * pagination: boolean, // Boolean to activate or deactivate the pagination
 * preserveSelectedRowKeys: boolean, // Boolean to preserve the selected rows
 * rowSelection: Function, // Function to execute when the user select a row
 * onRow: Function, // Function to execute when the user click on a row
 * }}
 */
//documment componente https://ant.design/components/table#scroll
const TableCheckComponent = ({
  rowKey,
  dataSource,
  columns,
  pagination,
  preserveSelectedRowKeys,
  scroll,
  rowSelection = () => {},
  onRow = () => {},
}) => {
  return (
    <>
      <Table
        rowKey={rowKey}
        className="tableMargin custom-table-styles m-2"
        rowSelection={rowSelection}
        preserveSelectedRowKeys={preserveSelectedRowKeys}
        pagination={pagination}
        columns={columns}
        dataSource={dataSource}
        onRow={onRow}
        scroll={scroll}
      />
    </>
  );
};
export default TableCheckComponent;
